export default "<div class=\"vfs-stepper\">\n  <ng-content></ng-content>\n</div>";